<template>
  <div class="signature-container">
    <div v-if="!isViewOnly" class="description text-center sign-guide">
      <span>Please drag your mouse/finger to sign!</span>
    </div>
    <img v-if="isViewOnly" :src="signature" :width="width" :height="height" />
    <VueSignaturePad
      v-else
      :width="width"
      :height="height"
      ref="signaturePad"
      :options="{ onBegin, onEnd }"
    />
    <i
      class="material-icons clear-button"
      @click="handleClickClearBtn()"
      v-if="!isViewOnly"
    >
      clear
    </i>
  </div>
</template>
<script>
export default {
  name: "SignaturePad",
  props: {
    height: String,
    width: String,
    isViewOnly: Boolean,
    value: String,
  },
  data() {
    return {};
  },
  computed: {
    signature: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  methods: {
    onBegin() {
      if (this.$refs.signaturePad) {
        this.$refs.signaturePad.resizeCanvas();
      }
    },
    onEnd() {
      this.save();
    },
    save() {
      const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
      if (isEmpty) {
        this.signature = null;
      } else {
        this.signature = data;
      }
    },
    handleClickClearBtn() {
      this.signature = null;
      this.$refs.signaturePad.clearSignature();
    },
  },
};
</script>
<style scoped>
.signature-container {
  border: solid 1px #ced4da;
  position: relative;
}
.clear-button {
  position: absolute;
  top: 0;
  right: 0;
  cursor: pointer;
}

.sign-guide {
  position: absolute;
  top: 0.5em;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/common/documents/SignaturePad.vue